import type { ChatScenarioRole } from "./types";

export function getMessageAlignmentClassName(role: ChatScenarioRole): string {
  if (role === "user") {
    return "tw-flex tw-justify-end tw-max-w-[90%] tw-ml-auto";
  }

  return "tw-flex tw-justify-start tw-max-w-[90%]";
}
